import React from "react";

import { useIntl } from "react-intl";

import InternalTag from "Components/InternalTag";
import { selectFeatureUsageBasedBillingEnabled } from "Reducers/featureFlags/featureFlags.selectors";
import { useAppSelector } from "Store/hooks";

import ChartInfo from "../services/ChartInfo";
import { PageTitileContainer, ProfilingHeader } from "../style";

const ProfilingPageTitle = () => {
  const intl = useIntl();
  const usageBilling = useAppSelector(selectFeatureUsageBasedBillingEnabled);

  return (
    <PageTitileContainer>
      <ProfilingHeader>
        {intl.formatMessage({ id: "profiling" })}
      </ProfilingHeader>
      <ChartInfo
        description={intl.formatMessage({
          id: "services_profiling_not_supported_description"
        })}
        title={intl.formatMessage({
          id: "services_profiling_not_supported"
        })}
      />
      {!usageBilling && <InternalTag />}
    </PageTitileContainer>
  );
};

export default ProfilingPageTitle;
